const {
  VUE_APP_PUBLIC_PATH,
  NODE_ENV,
} = process.env;

function environment() {
  switch (NODE_ENV) {
    case 'production':
      if (VUE_APP_PUBLIC_PATH) {
        return 'staging';
      }

      return 'production';
    case 'development':
    default:
      return 'development';
  }
}

export const env = environment();

export default function key(kind) {
  const storageKey = `credere:m:${kind}`;

  if (env !== 'production') {
    return `${storageKey}:${env}`;
  }

  return storageKey;
}
